import { Trans } from '@lingui/react'

import { Box } from '@twisto/components/atoms/box'
import { InlineButton, TextButton } from '@twisto/components/atoms/button'
import { Typography } from '@twisto/components/atoms/typography'
import { CheckmarkOutlineIcon } from '@twisto/icons'
import { styleUtils } from '@twisto/styles'
import { isString } from '@twisto/utils'

import * as styles from './promo-code-box.styles'

type Props = {
  onClick: () => void
  promoCode: string | undefined | null
}

export const PromoCodeBox = ({ promoCode, onClick }: Props) => {
  if (!isString(promoCode)) {
    return (
      <div css={styles.container}>
        <TextButton fullWidth color="ghost" onClick={onClick}>
          <Trans id="flow.additionalInfoIntroStep.promoCode.box.setPromoCode" />
        </TextButton>
      </div>
    )
  }

  const color = 'success'

  return (
    <div css={styles.container}>
      <Box
        color={color}
        css={styles.box}
        startAdornment={<CheckmarkOutlineIcon color={color} size="24" />}
      >
        <Typography css={styleUtils.fontWeight.medium} variant="b3">
          <Trans id="flow.additionalInfoIntroStep.promoCode.box.label" />
        </Typography>
        <InlineButton onClick={onClick}>
          <Trans id="flow.additionalInfoIntroStep.promoCode.box.editPromoCode" />
        </InlineButton>
      </Box>
    </div>
  )
}
